/**
 * Route for `amazon-advertising-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AmazonAdvertisingIntegrationPage } from "../features/amazon-advertising-integration/AmazonAdvertisingIntegrationPage";

export const amazonAdvertisingIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/amazon-advertising-integration",
	component: AmazonAdvertisingIntegrationPage,
});

export default amazonAdvertisingIntegrationRoute;
